import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, TextIn } from "@/components/forms/Field";
import { toast } from "sonner";

export default function NewLeadDialog({ open, onClose, stages, users, onCreated, module }) {
  const [f, setF] = useState({ name: "", email: "", phone: "", stage: "", owner: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    if (!f.name.trim()) { toast.error("Name is required"); return; }
    setBusy(true);
    try {
      const body = { ...Object.fromEntries(Object.entries(f).filter(([, v]) => v)), ...(module ? { module } : {}) };
      const { data } = await api.post("/crm/leads", body);
      toast.success("Lead created");
      setF({ name: "", email: "", phone: "", stage: "", owner: "" });
      onCreated(data._id);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border-strong)] max-w-md" data-testid="new-lead-dialog">
        <DialogHeader><DialogTitle className="text-base font-medium">New lead</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Field label="Name *"><TextIn value={f.name} onChange={set("name")} testid="new-lead-name" /></Field>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Email"><TextIn value={f.email} onChange={set("email")} testid="new-lead-email" /></Field>
            <Field label="Phone"><TextIn value={f.phone} onChange={set("phone")} testid="new-lead-phone" /></Field>
            <Field label="Stage">
              <select className="w-full px-2.5 py-1.5 rounded border text-sm" value={f.stage} onChange={(e) => set("stage")(e.target.value)} data-testid="new-lead-stage">
                {stages.map((s) => <option key={s} value={s === stages[0] ? "" : s}>{s}</option>)}
              </select>
            </Field>
            <Field label="Owner">
              <select className="w-full px-2.5 py-1.5 rounded border text-sm" value={f.owner} onChange={(e) => set("owner")(e.target.value)} data-testid="new-lead-owner">
                <option value="">Unassigned</option>
                {users.map((u) => <option key={u.email} value={u.email}>{u.name || u.email}</option>)}
              </select>
            </Field>
          </div>
          <button className="btn btn-primary w-full justify-center" onClick={save} disabled={busy} data-testid="new-lead-save">{busy ? "Creating…" : "Create lead"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
